import { createAction, props } from '@ngrx/store';
import { BillingitemMoveRequestV26 } from 'src/app/models-v26/billingitem-v26';
import { ContractTreeNodeV26 } from 'src/app/models-v26/contract-v26';
import { ActionResponse } from 'src/app/models/action-response';
import { MoveBillingitemsDueDatesV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/move-billingitems-wizard/activation-step/movebillingitems-due-date-info';
import { MoveBillingitemsInitStepV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/move-billingitems-wizard/init-step/init-step';

export const selectInitStep = createAction(
  '[V26 Catalog Page] Select Init Move Billingitems Information Step',
  props<{ initStep: MoveBillingitemsInitStepV26 }>(),
);

export const selectDueDatesStep = createAction(
  '[V26 Wizard Due Date Step] Select Move Billingitems Due Date Step',
  props<{ dueDatesStep: MoveBillingitemsDueDatesV26 }>(),
);

export const selectContractStep = createAction(
  '[V26 Wizard Billing account Step] Select Move Billingitems Billing account Step',
  props<{ contractStep: ContractTreeNodeV26[] }>(),
);

export const deleteContractStep = createAction('[V26 Wizard Contracts Step] Delete Move Billingitems Contract Step');

export const exitMoveBillingitemsWizard = createAction('[V26 MoveBillingitems Wizard Page] Exit Move Billingitems Wizard');

export const destroyWizard = createAction('[V26 MoveBillingitems Wizard Page] Destroy Wizard');

export const createNewMoveBillingitems = createAction(
  '[V26 Wizard Confirmation Step] Create Move Billingitems Information Step',
  props<{ request: BillingitemMoveRequestV26 }>(),
);

export const createNewMoveBillingitemsSuccess = createAction(
  '[V26 Wizard Confirmation Step] Create Move Billingitems Information Step Success',
  props<{ response: ActionResponse }>(),
);

export const createNewMoveBillingitemsFail = createAction(
  '[V26 Wizard Confirmation Step] Create Move Billingitems Information Step Fail',
  props<{ errorMessage: string }>(),
);
